import React, { FC } from "react"
import { graphql, useStaticQuery } from "gatsby"

import HubspotForm from "@components/HubspotForm/HubspotForm"

import "./InterviewBuilderForm.scss"

type InterviewBuilderFormProps = {
  onSubmitted?: () => void
}

const InterviewBuilderForm: FC<InterviewBuilderFormProps> = ({ onSubmitted }) => {
  const { hubspotForm } = useStaticQuery(graphql`
    query InterviewBuilderFormQuery {
      hubspotForm(alternative_id: {eq: "33310e80-dd05-4903-9241-7b873a33a2b7"}) {
        ...HubspotFormFragment
      }
    }
  `)

  return (
    <div className="InterviewBuilderForm">
      <HubspotForm
        {...hubspotForm}
        onSubmit={onSubmitted}
      />
    </div>
  )
}

export default InterviewBuilderForm
